export class SureFlowRatingCoilResponse {

  id!: number;
  totalCapacity!: number;
  sensibleCapacity!: number;
  leavingDryBulb!: number;
  leavingWetBulb!: number;
  leavingFluidTemperature!: number;
  fluidFlowRate!: number;
  airVelocity!: number;
  numberOfCircuits!: number;
  finsPerInch!: number;

}
